import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import FinanceRejected from "@/_MiniApps/Tamweel/FinanceRejected";
import { useSearchParams } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
var FinanceRejectedPage = function FinanceRejectedPage() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var haveanotherOrder = searchParams.get("haveanotherOrder");
  useEffect(function () {
    if (!haveanotherOrder) {
      navigateTo("/");
    }
  }, []);
  return /*#__PURE__*/React.createElement(Layout, {
    hideFooter: true,
    headHideLinks: true,
    hideAppBanner: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    hideHeaderOnmobile: false,
    custommobileHeader: null
  }, /*#__PURE__*/React.createElement(FinanceRejected, {
    haveanotherOrder: haveanotherOrder
  }));
};
export default FinanceRejectedPage;